<template>
	<div class="auth-overlay-popup-holder">
		<PopUpOverlay :contentData="contentData" v-if="displayAuth" @updateAuthpopup="toggleAuth" @saveSuccess="toggleNotification" :savedDrugs="savedDrug" :popupType="popupType"/>
		<div class="bookmark-holder drug-generic-name" v-metric="{ module: 'bkmk' }">
			<div class="bookmark-container" v-if="displayAuthText=='bookmark'" @click="toggleParentAuth(true, 'bookmark')">
				<div v-if="isMobile">
					<div class="icon-container">
						<span class="save-text">{{ translate('Save') }}</span>
						<span class="bookmark-icon save bookmark-saved">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<mask id="mask0_96_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
									width="24" height="24">
									<rect width="24" height="24" fill="#D9D9D9" />
								</mask>
								<g mask="url(#mask0_96_41)">
									<path
										d="M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18ZM12 15.8L17 17.95V5H7V17.95L12 15.8Z"
										fill="#3557FF" />
								</g>
							</svg>
						</span>
					</div>
				</div>
				<div v-else>
					<webmd-tooltip class="item" :content="`${translate('Save')} ${contentData.type === 'content' ? translate('article') : contentData.type }`" placement="right">
						<div slot="content">{{ translate('Save') }} {{contentData.type === 'content' ? translate('article') : contentData.type}}</div>
						<div class="icon-container">
							<span class="save-text">{{ translate('Save') }}</span>
							<span class="bookmark-icon save bookmark-saved">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<mask id="mask0_96_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
										width="24" height="24">
										<rect width="24" height="24" fill="#D9D9D9" />
									</mask>
									<g mask="url(#mask0_96_41)">
										<path
											d="M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18ZM12 15.8L17 17.95V5H7V17.95L12 15.8Z"
											fill="#3557FF" />
									</g>
								</svg>
							</span>
						</div>
					</webmd-tooltip>
				</div>
			</div>
			<div class="bookmark-container" v-else-if="displayAuthText=='auth'" @click="toggleParentAuth(true, 'auth')">
				<div v-if="isMobile">
					<div class="icon-container">
						<span class="save-text">{{ translate('Save') }}</span>
						<span class="bookmark-icon save bookmark-authenticate">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<mask id="mask0_96_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
									width="24" height="24">
									<rect width="24" height="24" fill="#D9D9D9" />
								</mask>
								<g mask="url(#mask0_96_41)">
									<path
										d="M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18ZM12 15.8L17 17.95V5H7V17.95L12 15.8Z"
										fill="#3557FF" />
								</g>
							</svg>
						</span>
					</div>
				</div>
				<div v-else>
					<webmd-tooltip class="item" :content="`${translate('Save')} ${contentData.type === 'content' ? translate('article') : contentData.type}`" placement="right">
						<div slot="content">{{ translate('Save') }} {{contentData.type === 'content' ? translate('article') : contentData.type}}</div>
						<div class="icon-container">
							<span class="save-text">{{ translate('Save') }}</span>
							<span class="bookmark-icon save bookmark-authenticate">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<mask id="mask0_96_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
										width="24" height="24">
										<rect width="24" height="24" fill="#D9D9D9" />
									</mask>
									<g mask="url(#mask0_96_41)">
										<path
											d="M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18ZM12 15.8L17 17.95V5H7V17.95L12 15.8Z"
											fill="#3557FF" />
									</g>
								</svg>
							</span>
						</div>
					</webmd-tooltip>
				</div>
			</div>
			<div class="bookmark-container" v-else-if="displayAuthText=='bookmarked'" @click="toggleParentAuth(true, 'delete')">
				<div v-if="isMobile">
					<div class="icon-container">
						<span class="save-text">{{ translate('Saved') }}</span>
						<span class="bookmark-icon saved bookmark-delete">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<mask id="mask0_96_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
									width="24" height="24">
									<rect width="24" height="24" fill="#D9D9D9" />
								</mask>
								<g mask="url(#mask0_96_41)">
									<path
										d="M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18ZM12 15.8L17 17.95V5H7V17.95L12 15.8Z"
										fill="#3557FF" />
								</g>
							</svg>
						</span>
					</div>
				</div>
				<div v-else>
					<webmd-tooltip class="item" :content="`${translate('Remove')} ${contentData.type === 'content' ? translate('article') : contentData.type}`" placement="right">
						<div slot="content">{{ translate('Remove') }} {{contentData.type === 'content' ? translate('article') : contentData.type}}</div>
						<div class="icon-container">
							<span class="save-text">{{ translate('Saved') }}</span>
							<span class="bookmark-icon saved bookmark-delete">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<mask id="mask0_96_41" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
										width="24" height="24">
										<rect width="24" height="24" fill="#D9D9D9" />
									</mask>
									<g mask="url(#mask0_96_41)">
										<path
											d="M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18ZM12 15.8L17 17.95V5H7V17.95L12 15.8Z"
											fill="#3557FF" />
									</g>
								</svg>
							</span>
						</div>
					</webmd-tooltip>
				</div>			
			</div>
		</div>
		<div class="notification-container" v-if="checkIfSaved">
			<div class="notify-success-icon"></div>
			<div class="success-text">
				<span class="navigation-text">{{ successText }}</span>
				<a href="https://member.webmd.com/profile" v-metric="{module: 'bkmk', link: 'profile'}" class="navigation-link">{{ successTextLink }}</a>
			</div>
			<div class="notify-close-icon" @click="toggleNotification(false)"></div>
		</div>
	</div>
</template>

<script>
import { Tooltip } from 'webmd-elements';
import PopUpOverlay from './PopUpOverlay.vue';
import registrationMixins from './components/mixins/registration.mixins.es6';
import CommonMixin from './components/mixins/commonapi.mixins.es6';
import { clone } from 'lodash';
export default {
	props:{
		contentData:Object,
		layoutType:String,
		contentLang:String
	},
	mixins: [registrationMixins, CommonMixin],
	data() {
		return {
			displayAuth : false,
			savedDrug : {},
			popupType : '',
			displayAuthText : null,
			checkIfSaved: false,
			isMobile: false,
			successText: 'To access saved content, click Profile in navigation or ',
			successTextLink: 'click here.'
		}
	},
	components: {
		WebmdTooltip: Tooltip,
		PopUpOverlay
	},
	watch:{
		displayAuthText(val){
			setTimeout(() => {
				this.updateBookMarkIcon(val)
			}, 1000);
			
		},
		contentData:{
            handler: function() {
				this.getLoginData();
            },
            deep: true
        }
	},
	created() {

		if (this.contentLang && this.contentLang === 'es_ES') {
			this.successText = 'Para acceder al contenido guardado, haz clic en Perfil en la navegación o haz ';
			this.successTextLink = 'clic aquí'

		}

	},
	mounted() {
		this.isMobile = window.matchMedia('screen and (max-width: 1024px)').matches;
		this.getLoginData();
	},
	methods:{
		updateBookMarkIcon(displayType=''){
			let bkArray = ['.bookmark-links'];
			bkArray.forEach((list)=>{
				let getElements = document.querySelectorAll(list);
				if(getElements && getElements.length>0){
					let getBookMark = document.getElementsByClassName('auth-overlay-popup-holder');
					if(getBookMark && getBookMark.length){
						getElements.forEach((list, index)=>{
							list.innerHTML = '';
							let cloneDiv = getBookMark[0].cloneNode(true);
							cloneDiv.addEventListener('click', this.addDynamicEvent)
							cloneDiv.getElementsByClassName('bookmark-holder')[0].insertAdjacentHTML('afterBegin', ('<div class="bookmark-save-text">Save this page</div>'))
							this.updateBookMark(cloneDiv , 'div', index)
							this.updateBookMark(cloneDiv , 'span', index)
							list.appendChild(cloneDiv)
						})
					}
				}
			})
		},
		updateBookMark(cloneDiv, target, index){
			const cloneDivcheck = cloneDiv.querySelectorAll(target)
			if(cloneDivcheck){
				cloneDivcheck.forEach(function (el) {
					el.setAttribute('data-bookmark', index);
				})
			}
		},
		positionIcon(){
			let checkHeader = document.querySelector('.auto-tabs');
			let checkIcon = document.querySelector('.bookmark-icon');
			if(checkHeader && checkIcon){
				checkIcon.style.top = (checkHeader.getBoundingClientRect().top + window.scrollY - 56)+'px'
			}
		},
		getLoginData(){
			if(this.contentData && Object.keys(this.contentData).length>0) {
				this.displayAuth = false;
				this.checkLogin();
			}
		},
		toggleNotification (flag) {
			console.log('notification flag has been clicked ', flag);
			if(flag) {
				this.displayAuthText = 'bookmarked';
				this.displayAuth = false;
			}
			this.checkIfSaved = flag;
			if(this.checkIfSaved) {
				setTimeout(() => {
					this.checkIfSaved = false;
				}, 10000);
			}
		},

		addDynamicEvent(event){
			let getClassList = [...event.target.classList];
			if(getClassList && getClassList.length){
				let getBookMark = event.target.getAttribute('data-bookmark');
				if(getClassList.includes('bookmark-saved')){
					this.toggleParentAuth(true, 'bookmark', 'dynamicEvent', getBookMark)
				}
				else if(getClassList.includes('bookmark-authenticate')){
					this.toggleParentAuth(true, 'auth','dynamicEvent', getBookMark);
				}
				else if(getClassList.includes('bookmark-delete')){
					this.toggleParentAuth(true, 'delete','dynamicEvent', getBookMark);
				}
			}
		},
		toggleParentAuth(displayMainAuth, pageName, eventName='', bookMarkIndex){
			if(this.contentData?.type === 'content') {
				this.$vwmdPageLink({moduleName: 'bkmk_site'});
			} else {
				if(eventName){
					if(this.contentData && this.contentData.dynamicOmniture){
						this.$vwmdPageLink({moduleName: this.contentData.dynamicOmniture[bookMarkIndex][`${(pageName=='delete')? 'remove' : 'save'}`]});
					}
				} else {
					if(this.contentData && this.contentData.initialOmniture){
						this.$vwmdPageLink({moduleName: this.contentData.initialOmniture[`${(pageName=='delete')? 'remove' : 'save'}`]});
					}
				}
			}
			this.toggleAuth(displayMainAuth, pageName, 'toggleParentAuth');
		},
		toggleAuth(displayMainAuth, pageName){
			this.popupType = pageName;
			if(pageName && pageName=='saveddrugs'){
				let webmdAuthp = this.getCookie('WBMD_AUTHP');
				if(webmdAuthp){
					this.checkBookMark(webmdAuthp, pageName)
				}
			}
			else{
				this.displayAuth = displayMainAuth;
			}
			if(displayMainAuth==false){
				this.popupType = ''
			}
		},
		removeDrugs(){
			this.popupType = 'delete'
			this.toggleAuth(true)
		},
		checkLogin(){
			let webmdAuth = this.getCookie('WBMD_AUTH');
			let webmdSauth = this.getCookie('WBMD_SAUTH');
			let webmdAuthp = this.getCookie('WBMD_AUTHP');
			if(webmdAuth && webmdSauth && webmdAuthp){
				this.checkBookMark(webmdAuthp)
			}
			else{
				this.displayAuthText = 'auth'
			}
		},
		async checkBookMark(access_token, pageName){
			let getData = await this.checkSaved(access_token,this.contentData);
			if(getData && getData.data){
				this.displayAuthText = 'bookmarked';
				this.savedDrug = getData.data;
				this.toggleNotification(true);
			}
			else{
				this.displayAuthText = 'bookmark';
			}
			if(pageName && pageName=='saveddrugs'){
				this.displayAuth = false;
			}
		},
		translate(val) {

			const i18n = {
				"es_ES": { // spanish lang
					"Save": "Guardar",
					"Saved": "Guardado",
					"article": "artículo",
					"Remove": "Eliminar"
				}
			};

			if (this.contentLang) {
				const copyLangStr = clone(val);
				if (this.contentLang && i18n[this.contentLang]) {
					// remove white spache from str value
					return i18n[this.contentLang][copyLangStr.replace(/\s/g, '')] || val;
				} else return val;
			}

			return val;
		},
	}
};
</script>
<style scoped lang="scss">
.auth-overlay-popup-holder{
	display: inline-block;
	.bookmark-holder{
		.bookmark-container {
			display: flex;
		}
		.bookmark-icon{
			cursor: pointer;
			width:40px;
			height:40px;
			position: absolute;
			top:-2px;
			@media(max-width:767px){
				right:10px;
			}
			@media(min-width:768px){
				left:20px;
			}
		}
	}
	
	.bookmark-text{
		color: #333132;
		font-family: "Source Sans Pro",Arial,sans-serif;
		font-size: 1.1875rem;
		font-weight: 400;
		line-height: normal;
		margin: 0 0 9px;
		text-transform: uppercase;
	}
	.notification-container {
		background: #00157c;
		bottom: 0;
		color: #f2f2f2;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		height: 70px;
		width: 100%;
		left: 0;
		z-index: 99999;
		@media(max-width:465px){
			height: 90px;
			padding: 20px 10px;
			line-height: 24px;
			justify-content: left;
		}
		.success-text {
			font-weight: 600;
			font-size: 1.125rem;
			font-family: "Source Sans Pro",Arial;
			.navigation-link {
				text-decoration: underline;
				cursor: pointer;
				color: #fff;
			}
		}
		.notify-success-icon {
			background: url('https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/images/check_circle.png') no-repeat;
			width: 24px;
			height: 24px;
			margin-right: 10px;
			@media(max-width:465px){
				width: 40px;
			}
		}
		.notify-close-icon {
			background: url('https://img.webmd.com/vim/live/webmd/consumer_assets/site_images/images/close_small.png') no-repeat;
			width: 13px;
			height: 13px;
			margin-left: 10px;
			@media(max-width:465px){
				width: 40px;
			}
		}
	}
	.icon-container, .tooltip {
		display: flex;
	}
}
div[role="tooltip"] {
	@media (max-width: 768px) {
		display: none;
	}
}

.v-modal{
	z-index: 99999 !important;
}
</style>